import { render, staticRenderFns } from "./UserDefault.vue?vue&type=template&id=63af2f7c"
import script from "./UserDefault.vue?vue&type=script&lang=js"
export * from "./UserDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports